// TODO: generate inidvidual SCSS file for better maintainability

import React, { memo } from 'react'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Badge from '@mui/material/Badge'
import { useTranslation } from 'react-i18next'
import { pathNameMap, namePathMap } from '../../../utils/constants'
import { useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import styles from './SideBar.module.scss'
import { theme } from '../../../styles/theme.style'

const SideBarRow = ({ pageName, icon, textColor, clickAction, activeKey, badge }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const isTelePresence = pageName === 'TelePresence'
  const effectiveKey = activeKey || pageName
  const isActive = isTelePresence
    ? pathNameMap[location.pathname] === theme.HOMEVU
    : pathNameMap[location.pathname] === effectiveKey

  return (
    <ListItem
      button
      key={pageName}
      onClick={clickAction || (() => navigate(namePathMap[pageName]))}
      className={
        isActive
          ? styles.sideBarRowActive
          : isTelePresence
            ? styles.sideBarRowTelePresence
            : styles.sideBarRow
      }
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: isTelePresence ? '20px 20px' : '14px 20px',
        minHeight: isTelePresence ? '68px' : '48px',
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        zIndex: 1,
        gap: '18px',
        boxSizing: 'border-box'
      }}
    >
      <ListItemIcon
        sx={{
          fontSize: isTelePresence ? 28 : 26,
          color: isTelePresence ? '#E0F7FA' : (isActive ? '#3594b6' : '#E0F7FA'),
          minWidth: 'auto',
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 'auto',
          flexShrink: 0,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '& svg': {
          filter: isTelePresence 
            ? 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2))'
            : (isActive 
                ? 'drop-shadow(0 2px 4px rgba(53, 148, 182, 0.4))' 
              : 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2))'),
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          opacity: isTelePresence ? 0.95 : (isActive ? 1 : 0.9)
          }
        }}
      >
        {badge > 0 ? (
          <Badge
            badgeContent={badge}
            color="error"
            max={99}
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '10px',
                minWidth: '18px',
                height: '18px',
                padding: '0 4px'
              }
            }}
          >
            {icon}
          </Badge>
        ) : (
          icon
        )}
      </ListItemIcon>
      <ListItemText
        primary={t(pageName)}
        sx={{
          color: isTelePresence ? '#E0F7FA' : (isActive ? '#ffd700' : '#FFFFFF'),
          textAlign: 'left',
          margin: 0,
          padding: 0,
          flex: 1,
          '& .MuiListItemText-primary': {
            fontSize: isTelePresence ? '15px' : '14px',
            fontWeight: isTelePresence ? 600 : (isActive ? 600 : 500),
            margin: 0,
            lineHeight: 1.5,
            letterSpacing: '0.01em',
            textShadow: isTelePresence
              ? '0 1px 2px rgba(0, 0, 0, 0.25)'
              : (isActive 
                ? '0 1px 2px rgba(0, 0, 0, 0.3)' 
                : '0 1px 2px rgba(0, 0, 0, 0.25)'),
            transition: 'all 0.2s ease',
            opacity: isTelePresence ? 0.95 : (isActive ? 1 : 0.95),
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }}
      />
    </ListItem>
  )
}

SideBarRow.propTypes = {
  pageName: PropTypes.string,
  icon: PropTypes.node,
  textColor: PropTypes.string,
  activeKey: PropTypes.string,
  clickAction: PropTypes.func,
  badge: PropTypes.number
}

export default memo(SideBarRow)
